import axios from "axios";
import { getBaseUrl } from "../../utils";
import Cookies from "js-cookie";

//  this pai is used for the
const get_profile = getBaseUrl() + "admin/getTodayStats";
export const get_dashboard_api = async (data) => {
  let config = {
    method: "get",
    // maxBodyLength: Infinity,
    url: get_profile,
    headers: {
      Authorization: `Bearer ${Cookies.get("token")}`,
    },
  };
  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};
//  this is for the  user chart
export const graphData_api = async (selectedRange) => {
  let config = {
    method: "get",
    url: getBaseUrl() + `/admin/getUserDashboard?period=${selectedRange}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
  };
  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

//  this is for the puja chart
export const pujaGraphData_api = async (selectedRange) => {
  let config = {
    method: "get",
    url: getBaseUrl() + `/admin/getPujaDashboard?period=${selectedRange}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
  };
  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
